import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const ChatPage = lazy(() => import("./web/ChatPage.js").then((m) => ({ default: m.ChatPage })));
const OverseePage = lazy(() => import("./web/OverseePage.js").then((m) => ({ default: m.OverseePage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));

export default defineWebModule({ manifest, pages: { "": ChatPage, "/oversee": OverseePage, "/settings": SettingsPage } });
